// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose, withProps } from 'recompose';

// Utils
import {
    getFirstSelectedColor,
    getSelectedElementType,
} from '../../workspace/toolbar/selectionTools/colorTools/colorUtils';
import { getColorDefaultHexValue } from '../../../common/colors/colorHelper';
import { isBoardLike, isLine } from '../../../common/elements/utils/elementTypeUtils';

// Actions
import { closePopup } from '../popupPanel/popupActions';
import setTemporarySelectedElementsColorStyles from '../../workspace/toolbar/selectionTools/colorTools/setTemporarySelectedElementsColorStyles';
import { updateSelectedElementsColors } from '../../workspace/toolbar/selectionTools/colorTools/colorActions';

// Components
import CustomColorInput from '../../workspace/toolbar/selectionTools/colorTools/CustomColorInput';

// Constants
import { DEFAULT_BOARD_COLOR, DEFAULT_ELEMENT_COLOR } from '../../../common/colors/colorConstants';
import { PopupIds } from '../popupPanel/popupConstants';

const selectedColorHexProps = (props) => {
    const { selectedElements } = props;
    if (!selectedElements) return {};

    const selectedColor = getFirstSelectedColor(selectedElements);
    let selectedColorHex = getColorDefaultHexValue(selectedColor);

    if (!selectedColorHex) {
        const firstElementType = getSelectedElementType(selectedElements);

        selectedColorHex =
            isBoardLike(firstElementType) || isLine(firstElementType) ? DEFAULT_BOARD_COLOR : DEFAULT_ELEMENT_COLOR;
    }

    return {
        selectedColorHex,
    };
};

const mapDispatchToProps = (dispatch) => ({
    setTempColor: setTemporarySelectedElementsColorStyles,
    setColor: (color) => {
        dispatch(updateSelectedElementsColors({ color, useExistingColorSpace: true }));
        dispatch(closePopup(PopupIds.COLOR, false));
    },
});

const SelectedElementColorPicker = (props) => {
    const { inputRef, setColor, setTempColor, selectedColorHex, onOpen, onBlur } = props;
    const colorInputRef = React.useRef();

    React.useImperativeHandle(inputRef, () => ({
        focus: () => colorInputRef.current.open(),
    }));

    return (
        <CustomColorInput
            ref={colorInputRef}
            setTempColor={setTempColor}
            setColor={setColor}
            initialColor={selectedColorHex}
            onOpen={onOpen}
            onBlur={onBlur}
        />
    );
};

SelectedElementColorPicker.propTypes = {
    inputRef: PropTypes.object,
    setColor: PropTypes.func,
    setTempColor: PropTypes.func,
    selectedColorHex: PropTypes.string,
    onOpen: PropTypes.func,
    onBlur: PropTypes.func,
};

const enhance = compose(connect(null, mapDispatchToProps), withProps(selectedColorHexProps));

export default enhance(SelectedElementColorPicker);
